/**
 * Reunião · Brasil Asset III (migrada do Streamlit; equivalência em
 * backend/tests_paginas/test_brasil_asset.py). Período padrão: 1A, contado de hoje.
 */
import { PaginaComAbas } from '../../components/PaginaComAbas';
import { opcoesPeriodo } from '../../lib/periodos';

// Usados enquanto a primeira resposta não chega; a API devolve a lista definitiva.
const PERIODOS = opcoesPeriodo(['ytd', '6m', '1a', '2a', '3a', '5a']);

export function BrasilAsset() {
  return (
    <PaginaComAbas
      descricao="Painel para a reunião com a Brasil Asset: curvas de juros, bolsas, moedas e spreads de debêntures."
      fonte="Banco Persevera (indicadores)"
      tituloSecao="Painel da reunião"
      titulo="Reunião · Brasil Asset III"
      caminho="/acompanhamentos-periodicos/brasil-asset-iii"
      filtro={{ tipo: 'periodo', padrao: '1a', periodos: PERIODOS, personalizado: true }}
    />
  );
}
